import React, { useState } from 'react';
import { useTranslation } from '@wix/cli-i18n';
import { useGenerationTask } from '../../hooks/use-generation-task.js';
import { generateCustomElement } from './generate.js';
import { useProjectModel } from '../../../../model.js';
import { useExtensions } from '../../../extensions/useExtensions.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../../CompleteGeneration.js';
import {
  ChooseNameStep,
  ChooseFolderStep,
  LinkDashboardPageStep,
  ChooseDashboardPageStep,
} from './steps.js';

export const useGenerateCustomElement = () => {
  const { t } = useTranslation();
  const { model } = useProjectModel();
  const { getExtensions } = useExtensions();

  const [elementName, setElementName] = useState<string>();
  const [elementFolder, setElementFolder] = useState<string>();
  const [linkDashboardPage, setLinkDashboardPage] = useState<boolean>();
  const [dashboardPageId, setDashboardPageId] = useState<string>();

  const dashboardPages = getExtensions('DashboardPage');

  const dashboardPagesExist = Boolean(dashboardPages.length);

  const extensionType = t('generate_command.flow.custom_element').toLowerCase();

  const shouldGenerate =
    !dashboardPagesExist ||
    (linkDashboardPage === false ? true : dashboardPageId);

  const generationTask = useGenerationTask(async () => {
    if (elementName && elementFolder && shouldGenerate) {
      return generateCustomElement(
        model.projectFolder,
        elementFolder,
        elementName,
        dashboardPageId
      );
    }
  }, [elementFolder, elementName, shouldGenerate]);

  return [
    <ChooseNameStep onSubmit={setElementName} elementName={elementName} />,
    <ChooseFolderStep
      onSubmit={setElementFolder}
      elementFolder={elementFolder}
      elementName={elementName}
    />,
    ...(dashboardPagesExist
      ? [<LinkDashboardPageStep onSubmit={setLinkDashboardPage} />]
      : []),
    ...(dashboardPagesExist && linkDashboardPage
      ? [<ChooseDashboardPageStep onSubmit={setDashboardPageId} />]
      : []),
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={extensionType}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        // https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-cli/supported-extensions/site-extensions/site-widgets/site-widget-extension-files-and-code
        learnMoreUrl: 'https://wix.to/rEfCfbY',
      })}
    />,
  ];
};
